import type * as React from 'react'
import { useBrainfishWidget } from '../../hooks/useBrainfishWidget'
import { HelpIcon, ChevronDownIcon } from '@buffer-mono/popcorn'
import type { Account } from '../../types'
import { getActiveProductFromPath } from '../../utils/getProduct'
import styles from './BrainfishWidget.module.css'

interface BrainfishWidgetProps {
  shouldShowBrainfish: boolean
  shouldMoveToHelpMenu: boolean
  user: Account
}

export const BrainfishWidget: React.FC<BrainfishWidgetProps> = (props) => {
  const { openBrainfish, closeBrainfish, isReady, isOpen } =
    useBrainfishWidget(props)
  const { shouldShowBrainfish, shouldMoveToHelpMenu } = props

  if (!shouldShowBrainfish || !isReady) {
    return null
  }

  if (shouldMoveToHelpMenu) {
    return <></>
  }

  const activeProduct = getActiveProductFromPath()
  const getProductClass = (): string => {
    switch (activeProduct) {
      case 'engage':
        return styles.engage
      case 'start_page':
        return styles.startPage
      default:
        return styles.default
    }
  }

  return (
    <button
      className={`${
        styles.triggerButton
      } ${getProductClass()} brainfish-trigger-button`}
      onClick={isOpen ? closeBrainfish : openBrainfish}
    >
      {isOpen ? (
        <ChevronDownIcon size="large" stroke={1} />
      ) : (
        <HelpIcon size="large" stroke={1} />
      )}
    </button>
  )
}
